function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#BAD8E6",
  d: "M0 14.4c0 .994.806 1.8 1.8 1.8h12.6c.994 0 1.8-.806 1.8-1.8V1.8c0-.994-.806-1.8-1.8-1.8H1.8C.806 0 0 .806 0 1.8v12.6zm13.497-4.502v3.6H9.898v-3.6h3.6zm-4.948 1.35v2.25h-3.6v-.9h2.7v-1.35h.9zm-4.95 1.35v.9H2.7v-.9h.9zm8.999-1.8h-1.8v1.8h1.8v-1.8zm-5.849-1.35v2.25h-.9v-2.25h.9zm-2.25 1.35v.9H2.7v-.9h1.8zm-.9-3.6v1.8h1.35v.9H2.7v-2.7h.9zm4.95 0v2.7h-.9v-1.8h-1.35v-.9h2.25zm3.149.45v.9h-1.8v-.9h1.8zm1.8 0v.9h-.9v-.9h.9zm-8.1-.45v.9H4.5v-.9h.9zM6.3 2.7v3.6H2.7V2.7h3.6zm7.198 0v3.6H9.898V2.7h3.6zm-4.948 0v3.6h-.9V2.7h.9zm-3.15.9H3.6v1.8h1.8V3.6zm7.199 0h-1.8v1.8h1.8V3.6z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F1F4F7",
  fillRule: "nonzero",
  d: "M3.6 3.6H16.2V16.2H3.6z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#009FE4",
  d: "M1.8 16.2c0 .994.806 1.8 1.8 1.8h12.6c.994 0 1.8-.806 1.8-1.8V3.6c0-.994-.806-1.8-1.8-1.8H3.6c-.994 0-1.8.806-1.8 1.8v12.6zm13.497-4.502v3.6h-3.599v-3.6h3.6zm-4.948 1.35v2.25h-3.6v-.9h2.7v-1.35h.9zm-4.95 1.35v.9H4.5v-.9h.9zm8.999-1.8h-1.8v1.8h1.8v-1.8zm-5.849-1.35v2.25h-.9v-2.25h.9zm-2.25 1.35v.9H4.5v-.9h1.8zm-.9-3.6v1.8h1.35v.9H4.5v-2.7h.9zm4.95 0v2.7h-.9v-1.8h-1.35v-.9h2.25zm3.149.45v.9h-1.8v-.9h1.8zm1.8 0v.9h-.9v-.9h.9zm-8.1-.45v.9H6.3v-.9h.9zM8.1 4.5v3.6H4.5V4.5h3.6zm7.198 0v3.6h-3.599V4.5h3.6zm-4.948 0v3.6h-.9V4.5h.9zm-3.15.9H5.4v1.8h1.8V5.4zm7.199 0h-1.8v1.8h1.8V5.4z"
}));

function SvgQrIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrIcon);
export default __webpack_public_path__ + "static/media/qr-icon.b72d786e.svg";
export { ForwardRef as ReactComponent };